/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import * as React from "react";
import whatsNewIcon from "./images/whats-new-icon.svg";
import { useEffect, useState } from "react";
import { CmsApi } from "api/CmsApi";
import { AppPath } from "components/AppPath";
import * as Router from "react-router-dom";
import { LocaleLink } from "utilities/NavigationUtilities";
import { useLocale } from "components/LocaleContext";

interface WhatsNewButtonProps {
  size: "l" | "xl";
}

const LATEST_UPDATES_SLUG_EN = "latest-updates";

export const WhatsNewButton: React.FC<WhatsNewButtonProps> = ({ size }) => {
  const [guideSlug, setGuideSlug] = useState(LATEST_UPDATES_SLUG_EN);
  const userLocale = useLocale();

  useEffect(() => {
    CmsApi.instance.getGuidePage(LATEST_UPDATES_SLUG_EN).then((page) => {
      if (page === undefined) {
        return;
      }

      if (page.attributes.locale !== userLocale) {
        const moreAppropriatePage = page.attributes.localizations.data.find(
          (localization) => {
            return (
              localization.attributes.locale.split("-")[0] ===
              userLocale.split("-")[0]
            );
          }
        );

        if (moreAppropriatePage !== undefined) {
          setGuideSlug(moreAppropriatePage.attributes.slug);
        }
      }
    });
  }, [userLocale]);

  const localizedWhatsNewUrl = Router.generatePath(AppPath.GUIDES, {
    guidePageSlug: guideSlug,
  });

  return (
    <LocaleLink to={localizedWhatsNewUrl}>
      <sp-button treatment="outline" size={size} variant="secondary">
        <img src={whatsNewIcon} slot="icon" aria-hidden="true" alt="" />
        {I18n.t("whats_new")}
      </sp-button>
    </LocaleLink>
  );
};
